module.exports = __webpack_public_path__ + "img/icon3.15942a0.png";